/**
 * Fassaden (Kapitel G).
 *
 * Gleiche Mechanik wie das Dach, ein Unterschied: Die Fassade ist im Luftbild
 * nicht zu sehen, sichtbar ist nur ihre Grundlinie. Die Arbeitsflaeche wird
 * deshalb aus Linie plus eingegebener Hoehe aufgespannt. Neigung 90 Grad,
 * Azimut als Normale auf die Wandlinie — und weil eine Linie zwei Normalen
 * hat, muss die Seite mitkommen (PV-G03).
 */
import { bogenInGrad, normiereGrad } from './typen.js';
export function spanneFassadeAuf(eingabe) {
    const dx = eingabe.b.x - eingabe.a.x;
    const dy = eingabe.b.y - eingabe.a.y;
    const laengeM = Math.hypot(dx, dy);
    if (laengeM < 1e-9)
        throw new Error('spanneFassadeAuf: Wandlinie hat keine Länge');
    if (eingabe.hoeheM <= 0)
        throw new Error('spanneFassadeAuf: Höhe muss positiv sein');
    // Rechts der Laufrichtung: (dy, -dx). Links: das Gegenteil.
    const nx = eingabe.seite === 'rechts' ? dy : -dy;
    const ny = eingabe.seite === 'rechts' ? -dx : dx;
    const unten = eingabe.sockelhoeheM ?? 0;
    const oben = unten + eingabe.hoeheM;
    const neigungGrad = eingabe.neigungGrad ?? 90;
    return {
        azimutGrad: normiereGrad(bogenInGrad(Math.atan2(nx, ny))),
        neigungGrad,
        laengeM,
        flaecheM2: laengeM * eingabe.hoeheM,
        ansicht: [
            { x: 0, y: unten },
            { x: laengeM, y: unten },
            { x: laengeM, y: oben },
            { x: 0, y: oben },
        ],
    };
}
/**
 * Aussparung in der Ansicht (PV-G04): Fenster, Tuer, Vorsprung.
 * Masse in Metern, gemessen ab dem Anfang der Wandlinie und ab Grund.
 */
export function aussparung(vonU, vonV, breiteM, hoeheM) {
    return [
        { x: vonU, y: vonV },
        { x: vonU + breiteM, y: vonV },
        { x: vonU + breiteM, y: vonV + hoeheM },
        { x: vonU, y: vonV + hoeheM },
    ];
}
//# sourceMappingURL=fassade.js.map